import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThumbsDownFill = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.5 1C5.85089 1 5.21929 1.21053 4.7 1.6C4.18071 1.98947 3.80164 2.53722 3.61989 3.16037L1.28989 11.1604C1.15958 11.6074 1.1351 12.0786 1.21839 12.5367C1.3017 12.9949 1.49056 13.4274 1.77 13.8C2.04944 14.1726 2.41179 14.475 2.82836 14.6833C3.24492 14.8916 3.70426 15 4.17 15H8.72825L8.02915 17.8803L8.02862 17.8824C7.87997 18.4859 7.86943 19.1152 7.99783 19.7234C8.12637 20.3322 8.39085 20.9042 8.77149 21.3965C9.15213 21.8888 9.6391 22.2887 10.196 22.5663C10.7529 22.844 11.3654 22.9922 11.9876 22.9999C12.3706 23.0047 12.7227 22.7902 12.8942 22.4477L16.3442 15.5577L16.3455 15.555C16.4113 15.4227 16.5054 15.307 16.6205 15.2158C16.8602 15.0261 17 14.7373 17 14.4316V2C17 1.44772 16.5523 1 16 1H6.5ZM20 1C19.4477 1 19 1.44772 19 2V14C19 14.5523 19.4477 15 20 15C20.7956 15 21.5587 14.6839 22.1213 14.1213C22.6839 13.5587 23 12.7956 23 12V4C23 3.20435 22.6839 2.44129 22.1213 1.87868C21.5587 1.31607 20.7956 1 20 1Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgThumbsDownFill);
export { ForwardRef as ReactComponent };
